import MediumSelector from "./MediumSelector.vue";

export type { MediumSelectorProps, Model } from "./MediumSelector.vue";
export default MediumSelector;
